import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { about, testimonials } from "../../mock";
import { CountUp } from "./Hero";

export function About() {
  return (
    <section id="about" className="bg-[#141416] py-28">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-[13.3%] grid lg:grid-cols-[0.8fr_1.2fr] gap-14 items-center">
        <div className="reveal">
          <span className="inline-block bg-yellow-400 text-black text-[12px] font-bold tracking-[0.12em] rounded-full px-4 py-1.5">OUR STORY</span>
          <h2 className="font-display font-bold text-white uppercase text-[44px] sm:text-[60px] leading-[0.95] tracking-[-0.03em] mt-6">
            Craftsmanship<br /><span className="text-yellow-400">since 2008</span>
          </h2>
          <p className="text-white/65 text-[18px] leading-relaxed mt-7 max-w-[340px]">{about.text}</p>
          <div className="flex gap-10 mt-12">
            {about.stats.map((s) => (
              <div key={s.label}>
                <div className="text-yellow-400 text-[52px] leading-none font-light"><CountUp to={s.value} /></div>
                <div className="text-white/50 text-[12px] tracking-[0.12em] uppercase mt-3">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="reveal">
          <div className="relative rounded-3xl overflow-hidden h-[380px] group">
            <img src={about.image} alt="Construction team" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
            <div className="absolute bottom-6 left-6 flex flex-wrap items-center gap-3">
              <span className="flex items-center gap-2 bg-white/90 text-black text-[13px] font-bold rounded-full px-4 py-2">
                <Icons.Medal className="w-4 h-4" /> AWARD WINNING
              </span>
              <span className="text-white text-[14px]">{about.award}</span>
            </div>
          </div>
          <div className="grid sm:grid-cols-2 gap-6 mt-6">
            {about.values.map((v) => {
              const I = Icons[v.icon];
              return (
                <div key={v.title} className="rounded-3xl bg-zinc-800/70 p-7 hover:bg-zinc-800 transition-colors duration-300">
                  <I className={`w-8 h-8 ${v.color}`} />
                  <h3 className="text-white font-bold text-[21px] mt-5">{v.title}</h3>
                  <p className="text-white/55 leading-relaxed mt-3">{v.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export function Testimonial() {
  const [i, setI] = useState(0);
  const [fade, setFade] = useState(true);
  const go = (n) => {
    setFade(false);
    setTimeout(() => { setI((n + testimonials.length) % testimonials.length); setFade(true); }, 250);
  };
  useEffect(() => {
    const t = setInterval(() => go(i + 1), 7000);
    return () => clearInterval(t);
  }, [i]); // eslint-disable-line
  const t = testimonials[i];
  return (
    <section className="bg-black py-24">
      <div className="max-w-[720px] mx-auto px-6 text-center">
        <Icons.Quote className="w-8 h-8 text-yellow-400/60 mx-auto mb-6" />
        <div className={`transition-opacity duration-300 ${fade ? "opacity-100" : "opacity-0"}`} data-testid="testimonial">
          <p className="text-white/80 italic text-[22px] sm:text-[25px] leading-snug">&ldquo;{t.quote}&rdquo;</p>
          <div className="flex items-center justify-center gap-4 mt-8">
            <span className="w-10 h-10 rounded-full bg-zinc-700 flex items-center justify-center text-xs text-white font-semibold">{t.initials}</span>
            <div className="text-left">
              <div className="text-white">{t.name}</div>
              <div className="text-yellow-400 text-[12px]">{t.role}</div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-4 mt-10">
          <button onClick={() => go(i - 1)} data-testid="testimonial-prev" className="w-10 h-10 rounded-full border border-white/20 text-white hover:bg-yellow-400 hover:text-black hover:border-yellow-400 transition-colors flex items-center justify-center"><Icons.ChevronLeft className="w-4 h-4" /></button>
          {testimonials.map((_, k) => (
            <button key={k} onClick={() => go(k)} className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${k === i ? "w-8 bg-yellow-400" : "w-3 bg-white/25"}`} />
          ))}
          <button onClick={() => go(i + 1)} data-testid="testimonial-next" className="w-10 h-10 rounded-full border border-white/20 text-white hover:bg-yellow-400 hover:text-black hover:border-yellow-400 transition-colors flex items-center justify-center"><Icons.ChevronRight className="w-4 h-4" /></button>
        </div>
      </div>
    </section>
  );
}
